import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@shared/shared.module";

import { RouterModule } from "@angular/router";
import { SupportRoutingModule } from "./support-routing.module";

import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { SupportService } from "@components/support/support.service";
import { SharedService } from "@shared/shared.service";
import { FormsModule } from "@angular/forms";

import { SupportComponent } from "@components/support/support.component";
import { AdvancedSearchComponent } from "./advanced-search/advanced-search.component";
import { NgSelectModule } from "@ng-select/ng-select";
// import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { OtaService } from "@components/central-ota/ota.service";
import { AlertModule } from "ngx-bootstrap/alert";
@NgModule({
  imports: [
    CommonModule,
    SupportRoutingModule,
    SharedModule,
    RouterModule,
    NgxDatatableModule,
    FormsModule,
    NgSelectModule,
    AlertModule,
    // OwlDateTimeModule,
    // OwlNativeDateTimeModule
  ],
  declarations: [
    AdvancedSearchComponent,
    SupportComponent,
  ],
  providers: [
    SupportService,
    SharedService,
    OtaService,
  ],
  exports: [SupportComponent],
})
export class SupportModule {}
